import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { organizationApi } from '../api/organization.api'
import { organizationKeys } from './query-keys'

export type { ClientRecord, ProjectRecord } from '../api/organization.api'

// ─── Clients ────────────────────────────────────────────────────────────────

export const useClients = () =>
	useQuery({
		queryKey: organizationKeys.clients.list(),
		queryFn: organizationApi.listClients,
	})

export const useCreateClient = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.createClient,
		onSuccess: () => void qc.invalidateQueries({ queryKey: organizationKeys.clients.all }),
	})
}

export const useUpdateClient = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.updateClient,
		onSuccess: () => void qc.invalidateQueries({ queryKey: organizationKeys.clients.all }),
	})
}

export const useDeleteClient = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.deleteClient,
		onSuccess: () => void qc.invalidateQueries({ queryKey: organizationKeys.clients.all }),
	})
}

// ─── Projects ───────────────────────────────────────────────────────────────

export const useProjects = () =>
	useQuery({
		queryKey: organizationKeys.projects.list(),
		queryFn: organizationApi.listProjects,
	})

export const useProject = (projectId: string) =>
	useQuery({
		queryKey: organizationKeys.projects.detail(projectId),
		queryFn: () => organizationApi.getProject(projectId),
		enabled: !!projectId,
	})

export const useCreateProject = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.createProject,
		onSuccess: () => void qc.invalidateQueries({ queryKey: organizationKeys.projects.all }),
	})
}

export const useUpdateProject = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.updateProject,
		onSuccess: () => void qc.invalidateQueries({ queryKey: organizationKeys.projects.all }),
	})
}

export const useDeleteProject = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: organizationApi.deleteProject,
		onSuccess: () => void qc.invalidateQueries({ queryKey: organizationKeys.projects.all }),
	})
}
